<div class="options" cdkTrapFocus>
  @for (config of configs$ | async; track config) {
    <ng-container [ngTemplateOutlet]="(config | isSelectOption) ? option : optGroup"
      [ngTemplateOutletContext]="{config: config}"
    ></ng-container>
    <ng-template #option let-config="config">
      <app-select-option [value]="config.value"
        [label]="config.label"
        [image]="config.image"
        [disabled]="config.disabled"
        [control]="control"
        [isLarge]="isLarge"
        (valueUpdated)="valueUpdated($event)"
      ></app-select-option>
    </ng-template>
    <ng-template #optGroup let-config="config">
      <div class="group">
        <label>{{ config.label }}</label>
        <div>
          @for (option of config.options; track option) {
            <app-select-option
              [value]="option.value"
              [label]="option.label"
              [image]="option.image"
              [disabled]="option.disabled"
              [control]="control"
              [isChild]="true"
              (valueUpdated)="valueUpdated($event)"
            ></app-select-option>
          }
        </div>
      </div>
    </ng-template>
  }
</div>
